export default {
  register: {
    verify: "/register/verify",
    request: "/register/requestemailvalidation"
  }
};
